import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { NavbarWithCallToAction } from "../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../brandConfig";

const PrivacyPolicyPage = () => {
  return (
    <>
      <NavbarWithCallToAction />

      <Box
        bg={getColor("background.main")}
        minHeight="100vh"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(60% 60% at 0% 0%, #112334 0%, transparent 50%),
            radial-gradient(50% 50% at 50% 50%, #369eff33 0%, transparent 100%)
          `,
          pointerEvents: 'none',
          zIndex: 0,
        }}
        sx={{
          '@keyframes snowfall': {
            '0%': {
              transform: 'translateX(-200px) translateY(-100px)',
              opacity: 0,
            },
            '5%': {
              opacity: 0.4,
            },
            '25%': {
              transform: 'translateX(25vw) translateY(25vh)',
              opacity: 0.8,
            },
            '50%': {
              transform: 'translateX(50vw) translateY(50vh)',
              opacity: 1,
            },
            '75%': {
              transform: 'translateX(75vw) translateY(75vh)',
              opacity: 0.8,
            },
            '95%': {
              opacity: 0.4,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 200px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '@keyframes snowfall-slow': {
            '0%': {
              transform: 'translateX(-250px) translateY(-100px)',
              opacity: 0,
            },
            '5%': {
              opacity: 0.3,
            },
            '30%': {
              transform: 'translateX(35vw) translateY(30vh)',
              opacity: 0.6,
            },
            '60%': {
              transform: 'translateX(65vw) translateY(60vh)',
              opacity: 0.8,
            },
            '95%': {
              opacity: 0.3,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 250px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '@keyframes snowfall-medium': {
            '0%': {
              transform: 'translateX(-180px) translateY(-100px)',
              opacity: 0,
            },
            '8%': {
              opacity: 0.5,
            },
            '40%': {
              transform: 'translateX(45vw) translateY(40vh)',
              opacity: 0.9,
            },
            '70%': {
              transform: 'translateX(80vw) translateY(70vh)',
              opacity: 0.7,
            },
            '92%': {
              opacity: 0.4,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 180px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-10%',
            width: '120%',
            height: '100%',
            backgroundImage: `
              radial-gradient(3px 3px at 10% 10%, rgba(255,255,255,0.6) 50%, transparent 50%),
              radial-gradient(4px 4px at 20% 30%, rgba(255,255,255,0.5) 50%, transparent 50%),
              radial-gradient(2px 2px at 15% 50%, rgba(255,255,255,0.7) 50%, transparent 50%),
              radial-gradient(5px 5px at 25% 20%, rgba(255,255,255,0.4) 50%, transparent 50%),
              radial-gradient(3px 3px at 30% 60%, rgba(255,255,255,0.6) 50%, transparent 50%),
              radial-gradient(6px 6px at 35% 40%, rgba(255,255,255,0.3) 50%, transparent 50%),
              radial-gradient(4px 4px at 40% 70%, rgba(255,255,255,0.5) 50%, transparent 50%),
              radial-gradient(2px 2px at 45% 15%, rgba(255,255,255,0.8) 50%, transparent 50%),
              radial-gradient(5px 5px at 50% 80%, rgba(255,255,255,0.4) 50%, transparent 50%)
            `,
            backgroundSize: '400px 400px, 500px 500px, 350px 350px, 450px 450px, 550px 550px, 600px 600px, 480px 480px, 420px 420px, 520px 520px',
            backgroundPosition: '0 0, 80px 60px, 160px 40px, 240px 100px, 320px 160px, 400px 80px, 480px 200px, 560px 20px, 640px 180px',
            animation: 'snowfall 25s linear infinite',
            pointerEvents: 'none',
            zIndex: 1,
          }
        }}
      >
        {/* Snow effect layers */}
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          pointerEvents="none"
          zIndex={1}
        >
          <Box
            position="absolute"
            top={0}
            left="-20%"
            width="140%"
            height="100%"
            opacity={0.6}
            sx={{
              backgroundImage: `
                radial-gradient(5px 5px at 5% 15%, rgba(255,255,255,0.4) 50%, transparent 50%),
                radial-gradient(3px 3px at 15% 35%, rgba(255,255,255,0.5) 50%, transparent 50%),
                radial-gradient(7px 7px at 10% 55%, rgba(255,255,255,0.3) 50%, transparent 50%),
                radial-gradient(4px 4px at 20% 25%, rgba(255,255,255,0.6) 50%, transparent 50%),
                radial-gradient(8px 8px at 25% 45%, rgba(255,255,255,0.25) 50%, transparent 50%),
                radial-gradient(6px 6px at 30% 65%, rgba(255,255,255,0.45) 50%, transparent 50%),
                radial-gradient(3px 3px at 35% 20%, rgba(255,255,255,0.7) 50%, transparent 50%)
              `,
              backgroundSize: '600px 600px, 700px 700px, 550px 550px, 650px 650px, 750px 750px, 680px 680px, 580px 580px',
              backgroundPosition: '0 0, 120px 140px, 240px 80px, 360px 200px, 480px 280px, 600px 120px, 720px 40px',
              animation: 'snowfall-slow 35s linear infinite',
            }}
          />

          <Box
            position="absolute"
            top={0}
            left="-15%"
            width="130%"
            height="100%"
            opacity={0.5}
            sx={{
              backgroundImage: `
                radial-gradient(4px 4px at 8% 20%, rgba(255,255,255,0.5) 50%, transparent 50%),
                radial-gradient(6px 6px at 18% 40%, rgba(255,255,255,0.35) 50%, transparent 50%),
                radial-gradient(3px 3px at 12% 60%, rgba(255,255,255,0.6) 50%, transparent 50%),
                radial-gradient(5px 5px at 22% 30%, rgba(255,255,255,0.4) 50%, transparent 50%),
                radial-gradient(7px 7px at 28% 50%, rgba(255,255,255,0.3) 50%, transparent 50%),
                radial-gradient(4px 4px at 32% 70%, rgba(255,255,255,0.55) 50%, transparent 50%)
              `,
              backgroundSize: '550px 550px, 650px 650px, 500px 500px, 600px 600px, 700px 700px, 580px 580px',
              backgroundPosition: '50px 30px, 150px 150px, 250px 90px, 350px 210px, 450px 270px, 550px 150px',
              animation: 'snowfall-medium 30s linear infinite',
            }}
          />
        </Box>

        {/* Hero Section */}
        <Box
          position="relative"
          width="100vw"
          height="400px"
          overflow="hidden"
          marginLeft="50%"
          transform="translateX(-50%)"
          backgroundImage="url('/assets/onesolarimages/abouthero.jpg')"
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg="rgba(0, 0, 0, 0.6)"
            zIndex={1}
          />

          <Container
            maxW="1200px"
            position="relative"
            zIndex={2}
            height="100%"
            display="flex"
            alignItems="center"
          >
            <Box
              width="100%"
              textAlign="center"
              color="white"
            >
              <Heading
                as="h1"
                fontSize={{ base: "4xl", md: "5xl", lg: "6xl" }}
                fontWeight="bold"
                textShadow="2px 2px 4px rgba(0,0,0,0.5)"
                fontFamily="'Open Sans', sans-serif"
                textTransform="uppercase"
              >
                Privacy Policy
              </Heading>
            </Box>
          </Container>
        </Box>

        {/* Main Content Section */}
        <Box
          bg="white"
          py={{ base: 16, md: 20 }}
          position="relative"
          zIndex={2}
        >
          <Container maxW="900px">
            <VStack spacing={10} align="stretch">
              {/* Last Updated */}
              <Box>
                <Text
                  fontSize={{ base: "sm", md: "md" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  fontStyle="italic"
                >
                  Last Updated: December 2024
                </Text>
              </Box>

              {/* Overview */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Overview
                </Heading>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                >
                  One Solar New Zealand is committed to protecting your privacy and managing your personal information in accordance with the New Zealand Privacy Act 2020. This privacy policy covers all services offered through our website and applies to all personal information we collect, use, and disclose.
                </Text>
              </Box>

              {/* Information Collection */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Information Collection
                </Heading>

                <VStack spacing={6} align="stretch">
                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Personal Information We Collect
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                      mb={3}
                    >
                      We collect personal information when you:
                    </Text>
                    <List spacing={2} ml={6}>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Visit our website
                        </Text>
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Register on the website
                        </Text>
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Place an order for our solar services
                        </Text>
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Subscribe to our newsletter
                        </Text>
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Fill out a contact or inquiry form
                        </Text>
                      </ListItem>
                    </List>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                      mt={3}
                    >
                      This information may include your name, email address, mailing address, phone number, and other relevant contact details.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Voluntary Submission
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      All personal information we collect is provided voluntarily by you. You can browse our website anonymously if you choose. However, refusing to provide certain information may limit your access to some of our services or features.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Non-Personal Data
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      We automatically collect certain technical information when you visit our website, including your browser type, operating system, internet service provider details, and browsing behavior. This information does not personally identify you.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Cookies
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      Our website uses cookies to enhance your browsing experience and keep records of your preferences. You can configure your browser to refuse cookies, though this may affect the functionality of certain website features.
                    </Text>
                  </Box>
                </VStack>
              </Box>

              {/* Information Usage */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  How We Use Your Information
                </Heading>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={3}
                >
                  One Solar New Zealand uses the information we collect for the following purposes:
                </Text>

                <List spacing={3} ml={6}>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Improve customer service:</strong> To respond effectively to your inquiries and support needs
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Personalize user experience:</strong> To understand how our customers use our services and website
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Enhance our services:</strong> To improve our website, products, and service offerings based on feedback
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Conduct promotions and surveys:</strong> To send promotional information about special offers and surveys
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Send newsletters:</strong> To provide requested updates and news about our solar solutions
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Respond to inquiries:</strong> To address your questions and provide accurate information
                    </Text>
                  </ListItem>
                </List>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mt={4}
                >
                  You can unsubscribe from our marketing emails at any time by clicking the "unsubscribe" link at the bottom of any email or by contacting us directly.
                </Text>
              </Box>

              {/* Information Disclosure */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Information Disclosure
                </Heading>

                <VStack spacing={6} align="stretch">
                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Non-Sale Policy
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      We do not sell, trade, or rent your personal information to third parties. Your privacy and trust are of paramount importance to us.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Shared Information
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                      mb={3}
                    >
                      We may share aggregated demographic information with our trusted business partners. This information does not identify individual users. Additionally, we may provide access to your information to third-party service providers who assist us in operating our website and business, such as:
                    </Text>
                    <List spacing={2} ml={6}>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Newsletter distribution services
                        </Text>
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Payment processing providers
                        </Text>
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color="#121c47" />
                        <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                          Website analytics services
                        </Text>
                      </ListItem>
                    </List>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                      mt={3}
                    >
                      These service providers are contractually obligated to keep your information confidential and use it only for the purposes for which we disclose it to them.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Targeted Advertising
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      Third-party advertising partners may place cookies on your browser for targeted advertising purposes. You can opt out of targeted advertising through industry opt-out programs or by adjusting your browser settings.
                    </Text>
                  </Box>
                </VStack>
              </Box>

              {/* Data Security & Access */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Data Security & Access
                </Heading>

                <VStack spacing={6} align="stretch">
                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Security Measures
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes secure servers, encryption protocols, and restricted access to personal data.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Access Requests
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      Under the New Zealand Privacy Act 2020, you have the right to request access to the personal information we hold about you. To make an access request, please submit a written request with appropriate identification documentation. A reasonable fee may apply for processing complex or extensive requests.
                    </Text>
                  </Box>
                </VStack>
              </Box>

              {/* Corrections & Complaints */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Corrections & Complaints
                </Heading>

                <VStack spacing={6} align="stretch">
                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Correcting Your Information
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      You have the right to request corrections to any inaccurate personal information we hold about you. You may also request that we delete your personal information, subject to our legal obligations to retain certain records.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      Privacy Concerns
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                      mb={3}
                    >
                      If you have any concerns or complaints about how we handle your personal information, please contact our Privacy Officer. We will investigate all complaints and respond to you within a reasonable timeframe.
                    </Text>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      If you are not satisfied with our response, you may contact the New Zealand Privacy Commissioner.
                    </Text>
                  </Box>
                </VStack>
              </Box>

              {/* Your Rights */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Your Privacy Rights
                </Heading>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={3}
                >
                  Under New Zealand privacy law, you have the following rights regarding your personal information:
                </Text>

                <List spacing={3} ml={6}>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      The right to access your personal information
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      The right to request correction of inaccurate information
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      The right to request deletion of your information
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      The right to object to certain processing of your information
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      The right to withdraw consent for marketing communications
                    </Text>
                  </ListItem>
                </List>
              </Box>

              {/* Contact Information */}
              <Box bg="#f8f9fa" p={8} borderRadius="lg">
                <Heading
                  as="h2"
                  fontSize={{ base: "xl", md: "2xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Contact Us
                </Heading>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={4}
                >
                  If you have any questions about this Privacy Policy or wish to exercise your privacy rights, please contact us:
                </Text>
                <VStack align="stretch" spacing={2}>
                  <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                    <strong>Email:</strong> hello@onesolarnz.co.nz
                  </Text>
                  <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                    <strong>Phone:</strong> 0800 767 024
                  </Text>
                  <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                    <strong>Address:</strong> 21c Somerset Street, Frankton, Hamilton, New Zealand
                  </Text>
                </VStack>
              </Box>

              {/* Changes to Policy */}
              <Box>
                <Heading
                  as="h2"
                  fontSize={{ base: "xl", md: "2xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Changes to This Policy
                </Heading>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                >
                  We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any significant changes by posting the updated policy on this page with a new "Last Updated" date. We encourage you to review this policy periodically.
                </Text>
              </Box>
            </VStack>
          </Container>
        </Box>

        <FooterWithFourColumns />
      </Box>
    </>
  );
};

export default PrivacyPolicyPage;
